import { useContext, useState } from 'react';
import { FlexContainer, Text, Spinner, Modals, ModalContext } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { useTranslation } from 'Hooks/useTranslation';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { routes } from 'Constants/routes';
import * as Styled from './styles';
import { useFetchGetReferralLinks } from './hooks';

const COPY_CHANNEL = 'copy';

const ShareModal = ({ isFiling }: { isFiling: boolean }): JSX.Element => {
  const { hideModal } = useContext(ModalContext);
  const [copied, setCopied] = useState(false);
  const { data, isLoading } = useFetchGetReferralLinks();
  const { t } = useTranslation(locizeNS.MODALS);
  const URL = data?.links.filter(item => item.channel === COPY_CHANNEL);

  const handleCopy = (): void => {
    if (URL) {
      navigator.clipboard.writeText(URL[0]?.url);
      setCopied(true);
    }
  };
  const handleCloseModal = (): void => {
    if (isFiling) {
      history.push(routes.DASHBOARD);
      hideModal();
    } else {
      hideModal();
    }
  };

  return (
    <Modals.Centered maxSize="M" hasClose onClose={handleCloseModal}>
      <Styled.Container direction="column">
        <Text mb="fds_size_16" color="dark_500" type="fds_text_bold_XL">
          {t('Referral.ShareModal.Title')}
        </Text>
        {isLoading ? (
          <Spinner size="M" justify="center" align="center" />
        ) : (
          <>
            <Styled.Section justify="space-between" align="center">
              <Text color="dark_500" type="fds_text_medium_L">
                {copied ? t('Referral.ShareModal.Copied') : t('Referral.ShareModal.Copy')}
              </Text>
              <Styled.SocialLink type="button" onClick={handleCopy}>
                <img
                  src={`${TAXDOWN_ASSETS_DOMAIN}/social/social_sharing_icons/icon_copy${
                    copied ? '_check' : ''
                  }.svg`}
                  alt={URL && URL[0]?.url}
                />
              </Styled.SocialLink>
            </Styled.Section>
            <FlexContainer direction="column">
              {data?.links?.map(
                (link: { [key: string]: string }, index: number) =>
                  link.channel !== 'copy' && (
                    <Styled.SocialLink target="_black" href={link.url} key={link.url}>
                      <Styled.Section
                        key={link.channel}
                        justify="space-between"
                        align="center"
                        borderBottomOnly={index !== 0}
                      >
                        <Text color="dark_500" type="fds_text_medium_L">
                          {link.title}
                        </Text>
                        <img
                          src={`${TAXDOWN_ASSETS_DOMAIN}/social/social_sharing_icons/icon_${link?.channel}.svg`}
                          alt={link.channel}
                        />
                      </Styled.Section>
                    </Styled.SocialLink>
                  )
              )}
            </FlexContainer>
          </>
        )}
      </Styled.Container>
    </Modals.Centered>
  );
};

export default ShareModal;
